// extracted by mini-css-extract-plugin
export default {"container":"visitedNotesItem_container__G1nQx","title":"visitedNotesItem_title__WXRTQ","code":"visitedNotesItem_code__SH6Vz"};